import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { FormHelperText } from '@mui/material';
import { UploadAvatar } from '../upload';

RHFUploadAvatar.propTypes = {
  name: PropTypes.string,  type: PropTypes.string,
};

export function RHFUploadAvatar({ name, type, helperText,defaultValue, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      type={type}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => {
        const checkError = !!error && !field.value;

        return (
          <div>
            <UploadAvatar  helperText={helperText}  error={checkError} {...other} file={field.value} />
            {checkError && (
              <FormHelperText error sx={{ px: 2, textAlign: 'center', color: 'red', fontSize: 12 }}>
                {error.message}
              </FormHelperText>
            )}
          </div>
        );
      }}
    />
  );
}


